import {
  Divider,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FiCheckCircle, FiMinusCircle, FiXCircle } from "react-icons/fi";

const HelpModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <ModalCloseButton />
        <ModalBody py={6}>
          <VStack w="full" align="flex-start" spacing={6}>
            <Text fontSize="lg" fontWeight="500">
              Offboarding/Account Removal
            </Text>
            <VStack w="full" align="flex-start" spacing={1}>
              <Text fontSize="sm" fontWeight="400" color="gray.600" pt={2}>
                You've been asked to complete some offboardings of an employee
                that your IT team believes you have the ability to complete.
              </Text>
              <Text fontSize="sm" fontWeight="400" color="gray.600" pt={2}>
                This means they'd like you to go into the assigned application
                and remove the account for that employee.{" "}
                <b>
                  Once you have done this, come back here and mark that account
                  as 'Removed'
                </b>. This will alert your IT team that it has been completed.
                If you cannot remove their account for any reason at all,{" "}
                <b>
                  then select 'Declined' and input a reason for not being able
                  to do so.
                </b>
              </Text>
            </VStack>
            <VStack w="full" align="flex-start" spacing={1}>
              <Text fontSize="sm" fontWeight="500" color="gray.600">
                What is Ploy?
              </Text>
              <Divider />
              <Text fontSize="sm" fontWeight="400" color="gray.600">
                Ploy is a SaaS management and security platform. We help
                companies like yours, protect and manage their SaaS
                applications. You can ask your IT or security team for more
                information.
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default HelpModal;
